import { ChangeEvent } from "react";
import { Input } from "components/common/Input/Input";
import { Translate } from "components/common/Translate/Translate";

interface SizeProps {
    width: number;
    height: number;
    handleWidthChange: (e: ChangeEvent<HTMLInputElement>) => void;
    handleHeightChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Size = ({ width, height, handleWidthChange, handleHeightChange }: SizeProps) => {
    return (
        <div className="flex max-w-full items-end gap-2">
            <div className="flex flex-col min-w-0 gap-2">
                <div className="capitalize">
                    <Translate keyName="width" />
                </div>
                <Input
                    type="number"
                    value={Math.round(width)}
                    min={0}
                    onChange={handleWidthChange}
                    data-testid="crop-settings-width"
                />
            </div>
            <div className="flex flex-col min-w-0 gap-2">
                <div className="capitalize">
                    <Translate keyName="height" />
                </div>
                <Input
                    type="number"
                    value={Math.round(height)}
                    min={0}
                    onChange={handleHeightChange}
                    data-testid="crop-settings-width"
                />
            </div>
        </div>
    );
};
